import { 
  DownloadTarget,
  LangTargetsMap,
  TargetLabelsMap,
  TargetLangsMap,
  ModuleTargetOverrides
} from './blockly.types';

const { Device, RaspberryPi, Script, Sketch } = DownloadTarget;

const TARGET_LABELS: TargetLabelsMap = {
  [Device]: 'On Laptop/Desktop',
  [RaspberryPi]: 'On Grok IoT Gateway',
};

const TARGET_LANG_CONSTRAINTS: TargetLangsMap = {
  [RaspberryPi]: ['python'] as const,
};

const DEFAULT_CODE_LANG_TARGETS: LangTargetsMap = {
  python: [Script] as const,
  arduino: [Sketch] as const,
};

const HARDWARE_MODULE_TARGETS = {
  python: [Device, RaspberryPi],
  arduino: [Device],
} as const;

const SCRIPT_ONLY_TARGETS = {
  python: [Script],
} as const;

const MODULE_TARGET_OVERRIDES: ModuleTargetOverrides = {
  robotics: HARDWARE_MODULE_TARGETS,
  iot: HARDWARE_MODULE_TARGETS,
  aiot: HARDWARE_MODULE_TARGETS,
  iiot: HARDWARE_MODULE_TARGETS,
  aiot_v2: HARDWARE_MODULE_TARGETS,
  
  data_science: SCRIPT_ONLY_TARGETS,
  artificial_intelligence: SCRIPT_ONLY_TARGETS,
};

export {
  TARGET_LABELS,
  TARGET_LANG_CONSTRAINTS,
  DEFAULT_CODE_LANG_TARGETS,
  MODULE_TARGET_OVERRIDES,
};
